import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import notify from '@scoutgg/ftw/source/services/notification'
import sourceManager from '../../services/source-manager'
import query from '../../services/query'
import normalize from '../../../helpers/normalize'
import template from './team-sources.jade'
import {Season, TeamSource, SeasonSource, Team} from '../../models'
import config from '@scoutgg/ftw/source/services/config'
import EditTeamSource from '../edit-team-source'
import Modal from '@scoutgg/ftw/source/services/modal'
import '../seasons'

function byName(a, b) {
  return (a.name || 'ZZZ').localeCompare(b.name || 'ZZZ')
}

function byPriority(a, b) {
  return a.priority - b.priority
}
function toKey(team) {
  return [
    normalize(team.name),
  ].join('|')
}

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('source', SeasonSource)
@Attribute('maxSources', Number)
export default class TeamSources extends HTMLElement {
  attached() {
    this.maxSources = 0
    this.showNa = false
    sourceManager.attached(this, 'team')
    this.update(Season.load({ active: true }))
      .then(() => (this.sport = this.season?.sport))
    this.reload()
  }

  uncache() {
    this.$cached = null
    this.render()
  }

  seasonChange() {
    this.reload()
  }

  changeSeason({season}) {
    query({season})
  }

  reload() {
    if(!this.season) return
    var params = {
      $reload: true,
      season: this.season._id,
    }
    return TeamSource.load(params).then(data => {
      Object.assign(this, data)
      this.$cached = null
      this.uniqueSeasonSources = data.seasonSources
      this.customSources = data.customSources.map(source => {
        return TeamSource.instance(source._id, source)
      })
      this.render()
    })
  }

  toggleShowNa() {
    this.showNa = !this.showNa
    this.uncache()
  }
  assignNew() {
    this.nonSources.forEach(source => {
      this.showScroll = true
      source.$new = true
    })
    this.$cached = null
    this.render()
  }

  clear() {
    this.teamSources.forEach(source => {
      this.showScroll = false
      delete source.$new
    })
    this.$cached = null
    this.render()
  }

  createSource(team) {
    let customSource = this.uniqueSeasonSources[0] && this.uniqueSeasonSources[0].source
    var source = TeamSource.create({
      source: customSource === 'steamAPI' ? 'steamAPI' : 'custom',
      priority: 0,
      team: team,
    })
    Object.assign(source, team, source)
    if(!this.customSource(team)) this.customSources.push(source)
    this.render()
  }

  createTeam() {
    fetch('/team-sources', {
      method: 'POST',
      body: JSON.stringify({season: this.season._id, team: this.team}),
      headers: {
        authorization: `Bearer sportyman ${config.token}`,
        'Content-Type': 'application/json',
      },
    }).then(() => this.reload())
      .then(() => {
        let newTeam = this.teams[this.teams.length - 1]
        this.createSource(newTeam)
      }).then(() => {
        this.save()
        this.modal.close()
      }).catch(err => {
        notify(err.message, {level: 'danger', timeout: 10000})
        console.error(err)
        this.render()
      })
  }

  async openModal(editTeam) {
    const result = await  Modal(
      EditTeamSource({ season: this.season, team: editTeam }),
      { hideCloseBtn: true },
    )
    if(!result?.team) {
      return
    }
    const { team } = result
    this.$isSubmitting = true
    await TeamSource.post('', {
      season: this.season._id,
      custom: [{
        team: team._id,
        name: team.name,
        abbr: team.abbr,
        tag: team.tag,
        shortTeamName: team.shortTeamName,
        source: 'custom',
        notAvailable: team.notAvailable,
      }]
    })
      .then(() => {
        notify('Sources updated', {level: 'success', timeout: 5000})
        return this.reload()
      })
      .catch(err => {
        notify(err.message, {level: 'danger', timeout: 10000})
        console.error(err)
        this.render()
      })
      .then(() => {
        this.$isSubmitting = false
      })

    this.render()
  }

  closeModal() {
    if(this.team._id === '-1') return this.createTeam()
    this.save()
    this.modal.close()
  }

  customSource(team) {
    return (this.customSources || []).find(s => s.team === team)
  }

  sources(team) {
    return (this.teamSources || [])
      .filter(s => s.team === team && s.priority > 0)
      .sort(byPriority)
  }

  updateFilter(e) {
    this.search = e.target.value
    this.$cached = null
    this.render()
  }

  save() {
    if(this.$isSubmitting) return
    this.$isSubmitting = true
    TeamSource.post('', {
      season: this.season._id,
      create: this.newTeams.map(s => s._id),
      unset: this.nonSources.map(s => s._id),
      custom: this.customSources.map(s => {
        return {
          team: s.teamId,
          name: s.name,
          abbr: s.abbr,
          tag: s.tag,
          shortTeamName: s.shortTeamName,
          uid: s.uid || null,
          source: s.source,
          notAvailable: s.notAvailable,
        }
      }),
      pair: this.teamSources
        .filter(s => s.team)
        .map(s => {
          return {
            _id: s._id,
            team: s.teamId,
            priority: s.priority,
          }
        }),
    })
      .then(() => {
        notify('Sources updated', {level: 'success', timeout: 5000})
        return this.reload()
      })
      .catch(err => {
        notify(err.message, {level: 'danger', timeout: 10000})
        console.error(err)
        this.render()
      })
      .then(() => {
        this.$isSubmitting = false
      })
    this.render()
  }

  changeSport(sport) {
    this.sport = sport || null
    this.render()
  }



  autoAssign() {
    sourceManager.autoAssign({
      attribute: 'team',
      sources: this.teamSources,
      models: this.teams,
      seasonSource: this.source,
      hash: toKey,
    })
    this.uncache()
  }

  get sortedTeams() {
    var maxSources = this.maxSources === (this.uniqueSeasonSources || [].length)
      ? Infinity
      : this.maxSources
    let sources = this.$cached || (this.$cached = sourceManager.sortedModels({
      attribute: 'team',
      search: this.search,
      sourceCount: maxSources,
      models: this.teams,
      sources: this.teamSources,
      sort: byName,
      match(team, search) {
        return ~normalize(team.name).indexOf(search)
      },
    }))
    if(this.showNa) {
      return sources
    } else {
      return sources.filter(s => !s.notAvailable)
    }
  }
  get nonSources() {
    return sourceManager.nonSources({
      attribute: 'team',
      sources: this.teamSources,
      seasonSource: this.source,
    }).sort(byName)
  }
  get newTeams() {
    return (this.teamSources || []).filter(t => !t.team && t.$new)
  }
  get activeSeasons() {
    const active = this.seasons.filter((s) => s.active)
    return Array.from(new Set(active.map(season => season.sport))).sort()
  }
}
